// Units of Measurement

export const uomListBySensorType = (sensor_type) => {
  switch (sensor_type) {
    case 'an_inputs':
      return [
        { key: 'volt', value: 'V (Volt)' },
        { key: 'millivolt', value: 'mV (Millivolt)' }
      ]

    case 'temperature':
    case 'ble_temp':
    case 'lls_temp':
    case 'eye_temp':
    case 'dallas_temp':
      return [
        { key: 'celsius', value: '°C (Celsius)' },
        { key: 'fahrenheit', value: '°F (Fahrenheit)' }
      ]

    case 'lls_fuel':
    case 'lls_fuel_level':
      return [
        { key: 'litre', value: 'ℓ (Litre)' },
        { key: 'gallon_us', value: 'gal (US)' },
        { key: 'gallon_uk', value: 'gal (UK)' }
      ]

    case 'eye_humidity':
      return [
        { key: 'percent', value: '% (Percentage)' }
      ]

    default:
      return []
  }
}

export const uomDefBySensorType = (sensor_type) => {
  switch (sensor_type) {
    case 'an_inputs':
      return 'volt'

    case 'temperature':
    case 'ble_temp':
    case 'lls_temp':
    case 'eye_temp':
    case 'dallas_temp':
      return 'celsius'

    case 'lls_fuel':
    case 'lls_fuel_level':
      return 'litre'

    case 'eye_humidity':
      return 'percent'

    default:
      return ''
  }
}

export const uomConvertFromStandard = (value, to_uom) => {
  switch (to_uom) {
    case 'volt':
      return value

    case 'millivolt':
      return value * 1000

    case 'celsius':
      return value

    case 'fahrenheit':
      return value * 1.8 + 32

    case 'litre':
      return value

    case 'gallon_us':
      return value * 0.264172

    case 'gallon_uk':
      return value * 0.219969204701183

    default:
      return value
  }
}

export const uomShortFormat = (value, uom, digits = null) => {
  if (digits === null) {
    if (value < 10) {
      digits = 3
    } else if (value < 100) {
      digits = 2
    } else {
      digits = 1
    }
  }

  switch (uom) {
    case 'volt':
      return value.toFixed(digits) + 'V'

    case 'millivolt':
      return value.toFixed(digits) + 'mV'

    case 'celsius':
      return value.toFixed(digits) + '°C'

    case 'fahrenheit':
      return value.toFixed(digits) + '°F'

    case 'litre':
      return value.toFixed(digits) + 'ℓ'

    case 'gallon_us':
      return value.toFixed(digits) + ' gal(US)'

    case 'gallon_uk':
      return value.toFixed(digits) + ' gal(UK)'

    default:
      return value.toFixed(digits)
  }
}



// WEBPACK FOOTER //
// ./src/common/uom.js